document.addEventListener('DOMContentLoaded', function () {
    var productGridContainer = document.querySelector('.product-grid-container');
    var isInitialLoad = true;
    var isFetching = false;
    var pendingRevealTimeout = null;

    if (!productGridContainer) return;

    function getGrid() { return document.getElementById('product-grid'); }

    function getNextUrl() {
        var grid = getGrid();
        return (grid && grid.dataset.nextUrl) ? grid.dataset.nextUrl : '';
    }

    function isScrolledToBottom() {
        var containerRect = productGridContainer.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return containerRect.bottom <= windowHeight + 300;
    }

    function showElements(count) {
        var elementsToShow = document.querySelectorAll('.scroll-infinite.d-none');
        for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
            elementsToShow[i].classList.remove('d-none');
        }
    }

    function countElements() {
        var grid = getGrid();
        var total = grid ? grid.dataset.total : null;
        if (!total) return;
        ['#ProductCountDesktop', '#ProductCount'].forEach(function (sel) {
            var el = document.querySelector(sel);
            if (el) el.innerHTML = total + ' productos';
        });
    }

    function fetchNextPage() {
        if (isFetching) return;
        var nextUrl = getNextUrl();
        if (!nextUrl) return;

        isFetching = true;

        fetch(nextUrl)
            .then(function (r) { return r.text(); })
            .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newItems = doc.querySelectorAll('#product-grid > li');
                var grid = getGrid();

                newItems.forEach(function (item) { grid.appendChild(item); });

                var newGrid = doc.getElementById('product-grid');
                grid.dataset.nextUrl = newGrid ? (newGrid.dataset.nextUrl || '') : '';

                showElements(show_first);
                countElements();
            })
            .catch(function () {
                var grid = getGrid();
                if (grid) grid.dataset.nextUrl = '';
            })
            .finally(function () { isFetching = false; });
    }

    function handleScroll() {
        if (isInitialLoad || !isScrolledToBottom()) return;
        var hiddenItems = document.querySelectorAll('.scroll-infinite.d-none');
        if (hiddenItems.length > 0) {
            showElements(show_first);
        } else if (getNextUrl()) {
            fetchNextPage();
        }
    }

    // Detect grid replacement after facets/sort AJAX update
    var observer = new MutationObserver(function () {
        if (isInitialLoad) return;
        clearTimeout(pendingRevealTimeout);
        pendingRevealTimeout = setTimeout(function () {
            showElements(show_first);
            countElements();
        }, 100);
    });

    observer.observe(productGridContainer, { childList: true, subtree: true });

    document.addEventListener('click', function (event) {
        if (
            event.target.closest('input[type="checkbox"]') ||
            event.target.closest('.active-facets__button-remove')
        ) {
            clearTimeout(pendingRevealTimeout);
            pendingRevealTimeout = setTimeout(function () {
                showElements(show_first);
                countElements();
            }, 2500);
        }
    });

    document.addEventListener('change', function (event) {
        if (event.target.matches('#SortBy, #SortBy-mobile, #SortBy-mobile-bar, select[name="sort_by"]')) {
            clearTimeout(pendingRevealTimeout);
            pendingRevealTimeout = setTimeout(function () {
                showElements(show_first);
                countElements();
            }, 2500);
        }
    });

    document.addEventListener('scroll', handleScroll, { passive: true });

    observer.disconnect();
    showElements(show_first);
    if (typeof checkProductQty === 'function') checkProductQty();
    isInitialLoad = false;
    observer.observe(productGridContainer, { childList: true, subtree: true });
    countElements();
});
